import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface AudioBufferLoaderOptions extends AjaxLoaderOptions {
    audioContext: AudioContext;
}

export class AudioBufferLoader extends AbstractAjaxLoader<AudioBuffer, AudioBufferLoaderOptions>{
    protected defaultOptions(): AudioBufferLoaderOptions {
        return {
            decoder: "arraybuffer",
            audioContext: null
        }
    }

    protected async convert(arrayBuffer: ArrayBuffer): Promise<AudioBuffer> {
        return new Promise<AudioBuffer>(
            (resolve, reject) => {
                this._options.audioContext.decodeAudioData(
                    arrayBuffer
                )
                    .then((buffer) => {
                        resolve(buffer);
                    })
                    .catch((reason) => {
                        reject(reason);
                    });
            }
        );
    }
}

registerLoader("audiobuffer", AudioBufferLoader);